import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";

export const smokeDetectExample: TemplateDefinition = {
  mode: "detect",
  slug: "smoke-detect-example",
  version: 1,
  title: "Disaster response",
  description: "Find the smoke source",
  subdescription: "Spot a wildfire's smoke source plus nearby landmarks from aerial footage.",
  thumbnailUuid: BASE_ASSETS.paradiseFireAerialExample.uuid,
  assets: [BASE_ASSETS.paradiseFireAerialExample],
  detect: {
    mediaUuid: BASE_ASSETS.paradiseFireAerialExample.uuid,
    categories: ["source of smoke", "lake"],
    config: {
      output: "box",
    },
  },
};
